module.exports = __webpack_public_path__ + "static/media/francoise-jaune.4fe9b9d2.jpg";